import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnmerge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_17_61)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 12C0 10.8954 0.89543 10 2 10H8C9.10457 10 10 10.8954 10 12V18C10 19.1046 9.10457 20 8 20H2C0.89543 20 0 19.1046 0 18V12ZM8 12H2V18H8V12Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M10 2C10 0.89543 10.8954 0 12 0H18C19.1046 0 20 0.89543 20 2V8C20 9.10457 19.1046 10 18 10H12C10.8954 10 10 9.10457 10 8V2Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_17_61",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 20,
			fill: "white"
		})
	}) })]
});
export default SvgUnmerge;
